<template @close="this.elPanels.qualification = 0">
    <el-main class="site-content">
        <div class="career-trajectory-page">
            <button v-if="curStep !== 1" class="career-trajectory-page__btn-prev c-primary" @click="prevStep">
                <icon-base viewBox="0 0 12 12" class="career-trajectory-page__btn-arrow">
                    <icon-arrow-left-second />
                </icon-base>

                Вернуться
            </button>

            <!-- 1 Шаг -->
            <template v-if="curStep === 1">
                <img src="@/assets/img/career-trajectory.jpg" alt="Карьерная траектория" class="career-trajectory-page__image">

                <div class="career-trajectory-page__text-block">
                    <p class="career-trajectory-page__text mt-0 mb-8">Узнайте кем вы&nbsp;можете стать!</p>
                    <h1 class="career-trajectory-page__heading mt-0 mb-24">Ответьте на&nbsp;вопросы и&nbsp;узнайте свою карьерную траекторию</h1>
                </div>

                <button type="button" class="career-trajectory-page__btn-start btn btn_success" @click="nextStep">Начать</button>

                <reference-button v-if="hintsCode" :hasFooter="hasFooter" :hintsCode="hintsCode" :content="hints.content" />
            </template>

            <!-- 2 Шаг -->
            <template v-if="curStep === 2">
                <h1 class="career-trajectory-page__heading mt-0 mb-24">Вы&nbsp;знаете свою квалификацию?</h1>

                <div class="career-trajectory-page__btns-block">
                    <button class="career-trajectory-page__btn-big" @click="nextStep(); youKnowQualification(true)">Знаю</button>
                    <button class="career-trajectory-page__btn-big" @click="nextStep(); youKnowQualification(false)">Не знаю</button>
                </div>

                <reference-button v-if="hintsCode" :hasFooter="hasFooter" :hintsCode="hintsCode" :content="hints.content" />
            </template>

            <!-- 3 Шаг -->
            <template v-if="curStep === 3">

                <!-- Я не знаю свою квалификацию -->
                <template v-if="!knowQualification">
                    <h1 class="career-trajectory-page__heading mt-0 mb-24">Заполните поля для поиска квалификации</h1>
                    <div class="career-trajectory-page__demanded-buttons">
                        <button class="btn career-trajectory-page__demanded-button" @click="allQuals" :class="{ 'btn_primary': !demandedQualsOnly }">
                          Все квалификации

                          <icon-base width="20" height="18" viewBox="-10 0 22 10" v-if="!demandedQualsOnly">
                            <icon-success/>
                          </icon-base>

                        </button>

                        <button class="btn career-trajectory-page__demanded-button" @click="demandedQuals" :class="{ 'btn_primary': demandedQualsOnly }">
                          Востребованные квалификации

                          <icon-base width="20" height="18" viewBox="-10 0 22 10" v-if="demandedQualsOnly">
                            <icon-success/>
                          </icon-base>

                        </button>
                    </div>

                    <div @keydown.enter.prevent.stop="searchAreas" class="mt-8">
                        <v-select class="select career-trajectory-page__select" label="name" placeholder="По области профессиональной деятельности (сфера деятельности)" v-model="curAreas" :clearable="true" :options="areas">
                            <template #no-options="{ search, searching, loading }">
                                <local-preloader v-if="areasPreloader" />
                                <span v-else>Введите в поисковую строку и нажмите Enter, чтобы загрузить ОПД</span>
                            </template>
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes">
                                    <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                </span>
                            </template>
                        </v-select>
                    </div>

                    <div @keydown.enter.prevent.stop="searchKinds" class="mt-8">
                        <v-select class="select career-trajectory-page__select" label="name" placeholder="По виду профессиональной деятельности (профессия)" v-model="curKind" :clearable="true" :options="kinds">
                            <template #no-options="{ search, searching, loading }">
                                <local-preloader v-if="kindsPreloader" />
                                <span v-else>Введите в поисковую строку и нажмите Enter, чтобы загрузить профессии</span>
                            </template>
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes">
                                    <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                </span>
                            </template>
                        </v-select>
                    </div>

                    <!-- <v-select class="select career-trajectory-page__select" label="name" placeholder="Выберите область профессиональной деятельности" v-model="curAreas" :clearable="false" :options="areas">
                        <template #no-options="{ search, searching, loading }">
                            <local-preloader v-if="areasPreloader" />
                            <span v-else>Введите в поисковую строку и нажмите Enter, чтобы загрузить квалификации</span>
                        </template>
                        <template #open-indicator="{ attributes }">
                            <span v-bind="attributes">
                                <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                            </span>
                        </template>
                    </v-select>

                    <div @keyup.enter="searchQualifications" class="mt-8">
                        <v-select class="select career-trajectory-page__select" label="name" placeholder="Выберите вид профессиональной деятельности" v-model="curKind" :clearable="false" :options="kinds">
                            <template #no-options="{ search, searching, loading }">
                                <local-preloader v-if="qualificationPreloader" />
                                <span v-else>Введите в поисковую строку и нажмите Enter, чтобы загрузить квалификации</span>
                            </template>
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes">
                                    <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                </span>
                            </template>
                        </v-select>
                    </div> -->

                    <div @click.stop="openFilterDialog('qualWorkFunctions', 'id')" class="mt-8">
                      <input
                          type="text"
                          class="input career-trajectory-page__input"
                          placeholder="По трудовой функции (должностные задачи/обязанности)"
                          :value="qualWorkFunctionsFilter.length ? `Выбрано: ${qualWorkFunctionsFilter.length} ТФ` : ''"
                          name="qualWorkFunctions_filter"
                      >
                    </div>

                    <div @keyup.enter="searchQualifications" class="mt-8">
                        <v-select class="select career-trajectory-page__select" label="name" placeholder="Наименование квалификации" v-model="curQualification" :clearable="true" :options="qualifications">
                            <template #no-options="{ search, searching, loading }">
                                <local-preloader v-if="qualificationPreloader" />
                                <span v-else>Введите в поисковую строку и нажмите Enter, чтобы загрузить квалификации</span>
                            </template>
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes">
                                    <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                </span>
                            </template>
                        </v-select>
                    </div>

                    <template v-if="curQualification">
                        <div v-if="orks.length > 0" class="career-trajectory-page__block">
                            <h2 class="career-trajectory-page__subheading mt-48 mb-24">Выберите интересующую карьерную траекторию</h2>

                            <ul class="entry-list mt-12">
                                <li class="entry-list__item career-trajectory-page__list-item-clickable" :class="{ 'career-trajectory-page__list-item_active': activeEl.id === item.id }" v-for="item in orks" :key="item.id" @click="changeActive(item)">
                                    <div class="entry">
                                        <div class="entry__inner">
                                            <div class="entry__item">
                                                <span class="career-trajectory-page__list-item-header">{{ `Разработчик: ${ item.organisation_name }`}}</span>
                                                <p class="career-trajectory-page__list-item-text">{{ item.name }}</p>
                                            </div>
                                            <div class="career-trajectory-page__icon_success entry__item" v-if="activeEl.id === item.id">
                                                <icon-base width="14" height="10" viewBox="0 0 12 10"><icon-success /></icon-base>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div v-else class="career-trajectory-page__block">
                            <h2 class="career-trajectory-page__subheading mt-48 mb-24">Выберите интересующую карьерную траекторию</h2>
                        </div>

                      <div class="career-trajectory-page__block">
                        <router-link :to="'/auto-trajectory/' + curQualification.id"
                                     v-if="Object.entries(this.autoTrajectoryQualifications).length > 1"
                                     class="entry-list__item career-trajectory-page__list-item-clickable"
                                     style="margin-top: 15px;display: inline-block; width: 100%;">
                          <div class="entry">
                            <div class="entry__inner">
                              <div class="entry__item">
                                <p class="career-trajectory-page__list-item-text">Посмотреть карьерную траекторию
                                  профессионального стандарта</p>
                              </div>
                              <div class="career-trajectory-page__icon_success entry__item">
                              </div>
                            </div>
                          </div>
                        </router-link>
                      </div>
                    </template>
                </template>

                <!-- Я знаю свою квалификацию -->
                <template v-else>
                    <h1 class="career-trajectory-page__heading mt-0 mb-24">Укажите наименование вашей квалификации</h1>

                    <div class="career-trajectory-page__demanded-buttons">
                      <button class="btn career-trajectory-page__demanded-button" @click="allQualsKnow" :class="{ 'btn_primary': !demandedQualsOnlyKnow }">
                        Все квалификации

                        <icon-base width="20" height="18" viewBox="-10 0 22 10" v-if="!demandedQualsOnlyKnow">
                          <icon-success/>
                        </icon-base>

                      </button>

                      <button class="btn career-trajectory-page__demanded-button" @click="demandedQualsKnow" :class="{ 'btn_primary': demandedQualsOnlyKnow }">
                        Востребованные квалификации

                        <icon-base width="20" height="18" viewBox="-10 0 22 10" v-if="demandedQualsOnlyKnow">
                          <icon-success/>
                        </icon-base>

                      </button>
                    </div>

                    <v-select class="select career-trajectory-page__select mt-8" label="name" placeholder="Наименование квалификации" v-model="curQualification" :clearable="true" :options="qualificationsKnow">
                        <template #no-options="{ search, searching, loading }">
                            <local-preloader v-if="qualificationPreloader" />
                            <span v-else>Введите в поисковую строку и нажмите Enter, чтобы загрузить квалификации</span>
                        </template>
                        <template #open-indicator="{ attributes }">
                            <span v-bind="attributes">
                                <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                            </span>
                        </template>
                    </v-select>

                    <template v-if="curQualification">
                        <div v-if="orks.length > 0" class="career-trajectory-page__block">
                            <h2 class="career-trajectory-page__subheading mt-48 mb-24">Выберите интересующую карьерную траекторию</h2>

                            <ul class="entry-list mt-12">
                                <li class="entry-list__item career-trajectory-page__list-item-clickable" :class="{ 'career-trajectory-page__list-item_active': activeEl.id === item.id }" v-for="item in orks" :key="item.id" @click="changeActive(item)">
                                    <div class="entry">
                                        <div class="entry__inner">
                                            <div class="entry__item">
                                                <span class="career-trajectory-page__list-item-header">{{ `Разработчик: ${ item.organisation_name }`}}</span>
                                                <p class="career-trajectory-page__list-item-text">{{ item.name }}</p>
                                            </div>
                                            <div class="career-trajectory-page__icon_success entry__item" v-if="activeEl.id === item.id">
                                                <icon-base width="14" height="10" viewBox="0 0 12 10"><icon-success /></icon-base>
                                            </div>
                                        </div>
                                    </div>
                                </li>


                            </ul>
                        </div>

                        <div v-else class="career-trajectory-page__block">
                            <h2 class="career-trajectory-page__subheading mt-48 mb-24">Выберите интересующую карьерную траекторию</h2>
                        </div>

                      <div class="career-trajectory-page__block">
                        <router-link :to="'/auto-trajectory/' + curQualification.id"
                                     v-if="Object.entries(this.autoTrajectoryQualifications).length > 1"
                                     class="entry-list__item career-trajectory-page__list-item-clickable"
                                     style="margin-top: 15px;display: inline-block; width: 100%;">
                          <div class="entry">
                            <div class="entry__inner">
                              <div class="entry__item">
                                <p class="career-trajectory-page__list-item-text">Посмотреть карьерную траекторию
                                  профессионального стандарта</p>
                              </div>
                              <div class="career-trajectory-page__icon_success entry__item">
                              </div>
                            </div>
                          </div>
                        </router-link>
                      </div>
                    </template>
                </template>

                <reference-button v-if="hintsCode" :hasFooter="hasFooter" :hintsCode="hintsCode" :content="hints.content" />
            </template>

            <!-- 4 Шаг -->
            <template v-if="curStep === 4">
                <h5 class="career-trajectory-page__subheading career-trajectory-page__subheading_gray mb-4">{{ activeEl.organisation_name }}</h5>
                <h4 class="career-trajectory-page__subheading mb-24">{{ activeEl.name }}</h4>

                <tabs caption=" " class="career-trajectory-page__block_full-screen" @clickOnTitle="changeTabs">
                    <tab title="Диаграмма">
                        <div class="diagram diagram_full-screen">
                          <div style="position: relative;">
                            <div style="position: absolute; margin-top: -90px;">
                              <ul class="legend-list diagram__legend-list_full-screen mb-16">
                                <li class="legend-list__item">
                                    <span class="legend-list__label">
                                        Связанные

                                        <icon-base viewBox="0 0 16 16" class="legend-list__icon"><icon-arrow-right-second/></icon-base>
                                    </span>
                                </li>
                                <li class="legend-list__item">
                                    <span class="legend-list__label legend-list__label_second">
                                        Родственные

                                        <icon-base viewBox="0 0 16 16" class="legend-list__icon"><icon-arrow-right-second/></icon-base>
                                    </span>
                                </li>

                                <li class="legend-list__item ml-auto" style="margin-right: 200px;">
                                  <button class="legend-list__btn" :disabled="scale === 1" @click="scaleUp">
                                    <icon-base viewBox="0 0 12 12">
                                      <icon-action/>
                                    </icon-base>
                                  </button>
                                  <button class="legend-list__btn ml-12" :disabled="scale === 0.1" @click="scaleDown">
                                    <icon-base viewBox="0 0 300 300">
                                      <icon-remove/>
                                    </icon-base>
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </div>

                            <tree ref="tree" :tree-data="treeInterrelations" @openQualificationsPanel="openQualification" :read="true" @openProgramsDialog="openProgramsDialog" />
                        </div>
                    </tab>

                    <tab title="Список">
                        <div class="career-trajectory-page__blocks" v-if="closeDiagram">
                            <ul class="entry-list mt-12">
                                <li class="entry-list__item career-trajectory-page__list-item-grey">
                                    <div class="entry">
                                        <div class="entry__inner">
                                            <div class="entry__item">
                                                <p class="career-trajectory-page__list-item-text">Связанные</p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li class="entry-list__item career-trajectory-page__list-item" v-for="item in interrelations.filter(el => el.relation_type === 'related')" :key="item.id">
                                    <div class="entry">
                                        <div class="entry__inner">
                                            <div class="entry__item">
                                                <p class="career-trajectory-page__list-item-text">{{ item.qualification_to.name }}</p>
                                            </div>

                                            <button v-if="item.education_programs" type="button" class="settings-btn" @click="loadPrograms(item)">
                                                <icon-base viewBox="0 0 12 14" class="settings-btn__icon"><icon-book /></icon-base>
                                            </button>
                                        </div>
                                    </div>
                                </li>
                            </ul>

                            <ul class="entry-list mt-12">
                                <li class="entry-list__item career-trajectory-page__list-item-grey">
                                    <div class="entry">
                                        <div class="entry__inner">
                                            <div class="entry__item">
                                                <p class="career-trajectory-page__list-item-text">Родственные</p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li class="entry-list__item career-trajectory-page__list-item" v-for="item in interrelations.filter(el => el.relation_type === 'inherited')" :key="item.id">
                                    <div class="entry">
                                        <div class="entry__inner">
                                            <div class="entry__item">
                                                <p class="career-trajectory-page__list-item-text">{{ item.qualification_to.name }}</p>
                                            </div>

                                            <button v-if="item.education_programs" type="button" class="settings-btn" @click="loadPrograms(item)">
                                                <icon-base viewBox="0 0 12 14" class="settings-btn__icon"><icon-book /></icon-base>
                                            </button>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </tab>
                </tabs>

                <reference-button v-if="hintsCode" :hasFooter="hasFooter" :hintsCode="hintsCode" :content="hints.content" />

            </template>
        </div>

        <!-- DIALOGS -->


      <div :style="this.elPanels.qualification ? {} : {'display':'none'}">
        {{this.elPanels.qualification}}
        <qualification-panel
          v-if="qualification"
          :read="true"
          :work-functions-by-qualification-loader="workFunctionsByQualificationLoader"
          :programs-by-qualification-loader="programsByQualificationLoader"
          :standart-loader="standartLoader"
          :style="{ position: 'absolute', zIndex: 99, top: '11.7rem', height: 'calc(100vh - 11.7rem)' }"
        />
<!--        <all-info-about-qualification-panel-->
<!--            v-if="qualification"-->
<!--            :read="true"-->
<!--            :activeTraining="activeTraining"-->
<!--            :workFunctionsByQualificationLoader="workFunctionsByQualificationLoader"-->
<!--            :programsByQualificationLoader="programsByQualificationLoader"-->
<!--            :standartLoader="standartLoader"-->
<!--            :hardSkillsByQualificationLoader="hardSkillsByQualificationLoader"-->
<!--            :softSkillsByQualificationLoader="softSkillsByQualificationLoader"-->
<!--            :interrelationsByQualificationLoader="interrelationsByQualificationLoader"-->
<!--            :style="{ position: 'absolute', zIndex: 99, top: '11.7rem', height: 'calc(100vh - 11.7rem)' }"-->
<!--        />-->
      </div>


      <!-- Dialogs -->
      <filter-pk-dialog :preloader="filterPreloader" :activeFilters="activeFilters" :filterBy="filterBy"
                         :filterValue="filterValue" :qualWorkFunctions="qualWorkFunctions"
                        :curAreas="curAreas" :curKind="curKind" :curQual="curQualification"
                        :demanded="demandedQualsOnly"
                        @addFilters="addFilters" />
<!--      <programs-dialog mode="interrelations"-->
<!--                       :qualificationId="activeTraining.qualification_to.id"-->
<!--                       :qualification-from-id="activeTraining.parent.id"-->
<!--                       v-if="showTrainingProgramDialog"-->
<!--                       :trainingId="activeTraining.id"-->
<!--                       :read="true" />-->

      <programs-dialog-view
          v-if="this.elDialogs.viewTrainingPrograms"
          :visible="elDialogs.viewTrainingPrograms"
          @close="elDialogs.viewTrainingPrograms = false"
          :programs="this.trainingPrograms"
      />

      <programs-dialog mode="interrelations"
                       :qualificationId="activeTraining.qualification_to ? activeTraining.qualification_to.id : 0"
                       :trainingId="activeTraining.id"
                       :qualificationFromId="curQualification ? curQualification.id : null"
                       :read="true" />


    </el-main>

</template>

<script>
import {mapActions, mapState, mapMutations, mapGetters} from 'vuex';

import constants from '@/constants.js';
import panel from '@/mixins/panel';
import dialog from '@/mixins/dialog';

import AllInfoAboutQualificationPanel from '@/components/WizardPanels/AllInfoAboutQualificationPanel';
import LocalPreloader from '@/components/LocalPreloader'
import Tab from '@/components/Tabs/Tab';
import Tabs from '@/components/Tabs/Tabs';
import Tree from '@/components/Tree/Tree';
import ReferenceButton from '@/components/ReferenceButton.vue';
import ProgramsDialog from '@/components/Dialogs/ProgramsDialog';
import FilterPkDialog from '@/components/Dialogs/FilterPkDialog.vue';
import app from "@/App";
import ProgramsDialogView from "@/components/Dialogs/ProgramsDialogView";
import QualificationPanel from "@/components/WizardPanels/QualificationPanel.vue";

export default {
    mixins: [ dialog, panel ],
    components: {
      QualificationPanel,
      ProgramsDialogView,
        AllInfoAboutQualificationPanel,
        ProgramsDialog,
        LocalPreloader,
        Tab,
        Tabs,
        Tree,
        ReferenceButton,
        FilterPkDialog,
    },
    data() {
        return {
            showTrainingProgramDialog: false,
            openMore: false,
            knowQualification: false,
            activeTraining: false,
            disabledNextStep: true,
            closeDiagram: false,

            qualificationPreloader: false,
            okzsLoader: false,
            okvedsLoader: false,
            workFunctionsByStandardLoader: false,
            workFunctionsByQualificationLoader: false,
            programsByQualificationLoader: false,
            standartLoader: false,
            hardSkillsByQualificationLoader: false,
            softSkillsByQualificationLoader: false,
            interrelationsByQualificationLoader: false,
            demandedQualsOnly: false,
            demandedQualsOnlyKnow: false,
            qualificationsKnow: [],
            hasFooter: false,

            workFunctionPreloader: false,
            areasPreloader: false,
            kindsPreloader: false,

            curQualification: null,
            curAreas: null,
            lastAreas: null,
            curKind: null,
            lastKind: null,
            curFunction: null,
            lastFunction: null,

            activeEl: {},

            curStep: 1,
            scale: 1,

            filterPreloader: false,
            activeFilters: [],
            filterBy: '',
            filterValue: '',
            qualWorkFunctionsFilter: [],
            qualWorkFunctions: [],
            workFunctions: [],


            trainingPrograms: [],
        }
    },
    methods: {
        ...mapActions('career', [
            'LOAD_WORK_FUNCTIONS_BY_QUERY',
            // 'SILENT_LOAD_ALL_WORK_FUNCTIONS',
            'LOAD_AREAS_BY_QUERY',
            'LOAD_KINDS_BY_QUERY',
            'SILENT_LOAD_KINDS_BY_FUNC',
            'SILENT_LOAD_AREAS_BY_FUNC',
            'SILENT_LOAD_KINDS_BY_AREA',
            // 'LOAD_WORK_FUNCTIONS_BY_AREA',
            'SILENT_LOAD_AREAS_BY_KIND',
            'SILENT_LOAD_AREAS_BY_QUAL',
            'SILENT_LOAD_KINDS_BY_QUAL',
            'LOAD_ALL_AREAS',
            'SILENT_LOAD_ALL_KINDS',
            // 'SILENT_LOAD_WORK_FUNCTIONS_BY_KIND',

            'LOAD_INTERRELATIONS_BY_QUALIFICATION',
            // 'LOAD_AREAS',
            'LOAD_QUALIFICATIONS',
            // 'LOAD_KINDS',
            'SILENT_LOAD_ORKS',
            'SILENT_LOAD_QUALIFICATIONS',
            'LOAD_QUALIFICATION_AUTO_INTERRELATIONS'
        ]),
        ...mapMutations('ork', ['SET_ORK_ID']),
        ...mapActions('editor', [
            'LOAD_QUALIFICATION',
            'SILENT_LOAD_WORK_FUNCTIONS_BY_QUALIFICATION',
            'SILENT_LOAD_OKVEDS',
            'SILENT_LOAD_OKZS',
            'LOAD_TRAININGS',
            'SILENT_LOAD_WORK_FUNCTIONS_BY_STANDARD',
            'SILENT_LOAD_STANDARD',
            'RESET_STANDARD',
            'SILENT_LOAD_PROGRAMS_BY_QUALIFICATION',
            'SILENT_LOAD_HARD_SKILLS_BY_QUALIFICATION',
            'SILENT_LOAD_SOFT_SKILLS_BY_QUALIFICATION',
            'SILENT_LOAD_INTERRELATIONS_BY_QUALIFICATION',
            'LOAD_KINDS',
            'LOAD_AREAS',
            'LOAD_AREAS_NO_ORK',
        ]),
        ...mapActions('hints', [
            'LOAD_HINTS',
        ]),
        ...mapMutations('common', ['SET_CURRENT_PARENT', 'SET_SHOW_DIAGRAM_ADD']),
        ...mapMutations('career', ['SET_KINDS', 'SET_AREAS', 'SET_QUALIFICATIONS', 'SET_WORK_FUNCTIONS']),

        nextStep() {
            this.curStep++
        },
        prevStep() {
            this.activeEl = {}
            this.curStep--;

          this.elPanels.qualification = 0;
        },
        goToStep(step) {
            this.curStep = step
        },

        scaleUp() {
            this.scale = (this.scale * 10 + 1) / 10
        },
        scaleDown() {
            this.scale = (this.scale * 10 - 1) / 10
        },
        async openProgramsDialog(training) {
          await this.LOAD_TRAININGS(training.id)
          this.activeTraining = training;
          this.trainingPrograms = this.trainings.education_programs;
          this.elDialogs.viewTrainingPrograms = true;

        },
        async allQuals() {
            this.demandedQualsOnly = false;

            await this.loadAllAreas();

            await this.SET_KINDS([]);
            await this.SET_QUALIFICATIONS([]);
            this.lastKind = null;
            this.lastAreas = null;
            this.lastFunction = null;

            await this.loadQuals();
        },
        async demandedQuals() {
            this.demandedQualsOnly = true;

            this.curAreas = null;
            this.curFunction = null;
            this.curKind = null;

            await this.loadAllAreas();

            await this.SET_KINDS([]);
            await this.SET_QUALIFICATIONS([]);
            this.lastKind = null;
            this.lastAreas = null;
            this.lastFunction = null;

            await this.loadQuals();
        },
        async allQualsKnow() {
            this.demandedQualsOnlyKnow = false;
            this.qualificationsKnow = this.qualifications;
        },
        async demandedQualsKnow() {
            this.demandedQualsOnlyKnow = true;
            this.qualificationsKnow = this.qualifications.filter(el => el.is_demanded === true);

            if (this.qualificationsKnow.filter(el => el.id === this.curQualification.id).length === 0) {
              this.curQualification = null;
            }
        },

        async openQualification(obj, approved = true) {
            await this.LOAD_QUALIFICATION({id: obj, approved});

            this.elPanels.qualification = 1;

            this.standartLoader = true
            this.workFunctionsByQualificationLoader = true
            this.programsByQualificationLoader = true
            this.hardSkillsByQualificationLoader = true
            this.softSkillsByQualificationLoader = true
            this.interrelationsByQualificationLoader = true

            if (this.qualification.standard_id) {
              await this.loadStandart(this.qualification.standard_id);
            }

            if (!this.qualification.standard_id) {
              this.standartLoader = false;
              this.RESET_STANDARD();
            }

            await this.loadWorkFunctionsByQualification(this.qualification.id);
            await this.loadWorkProgramsByQualificationLoader(this.qualification.id);
            await this.loadSoftSkillsByQualification(this.qualification.id);
            await this.loadHardSkillsByQualification(this.qualification.id);
            await this.loadInterrelationsByQualification(this.qualification.id);
        },

        async loadOkzs() {
            await this.SILENT_LOAD_OKZS(),
                this.okzsLoader = false
        },
        async loadOkveds() {
            await this.SILENT_LOAD_OKVEDS(),
                this.okvedsLoader = false
        },
        async loadWorkFunctionsByStandard(id) {
            await this.SILENT_LOAD_WORK_FUNCTIONS_BY_STANDARD(id)
            this.workFunctionsByStandardLoader = false
        },
        async loadWorkFunctionsByQualification(id, approved = true) {
            await this.SILENT_LOAD_WORK_FUNCTIONS_BY_QUALIFICATION({id, approved}),
                this.workFunctionsByQualificationLoader = false
        },
        async loadWorkProgramsByQualificationLoader(id, approved = true) {
            await this.SILENT_LOAD_PROGRAMS_BY_QUALIFICATION({id, approved}),
                this.programsByQualificationLoader = false
        },
        async loadStandart(id, approved = true) {
            await this.SILENT_LOAD_STANDARD({id, approved});
                this.standartLoader = false
        },
        async loadHardSkillsByQualification(id, approved = true) {
            await this.SILENT_LOAD_HARD_SKILLS_BY_QUALIFICATION({id, approved}),
                this.hardSkillsByQualificationLoader = false
        },
        async loadSoftSkillsByQualification(id, approved = true) {
            await this.SILENT_LOAD_SOFT_SKILLS_BY_QUALIFICATION({id, approved}),
                this.softSkillsByQualificationLoader = false
        },
        async loadInterrelationsByQualification(id, approved = true) {
            await this.SILENT_LOAD_INTERRELATIONS_BY_QUALIFICATION({id, approved})
            this.interrelationsByQualificationLoader = false
        },

        async searchQualifications(val) {
            this.qualificationPreloader = true

            const kindId = this.curKind ? this.curKind.id : null
            const funcId = this.curFunction ? this.curFunction/*.id*/ : null
            const areaId = this.curAreas ? this.curAreas.id : null

            const params = {
                query_params: val.target.value,
                area_id: areaId,
                kind_id: kindId,
                func_id: funcId,
                demanded: this.demandedQualsOnly,
            }

            await this.SILENT_LOAD_QUALIFICATIONS(params)
            this.qualificationPreloader = false
        },

        async searchWorkFunctions(val) {
            this.workFunctionPreloader = true
            // console.log(val.target.value)
            await this.LOAD_WORK_FUNCTIONS_BY_QUERY({query: val.target.value, demanded: this.demandedQualsOnly})
            this.workFunctionPreloader = false
        },

        async searchAreas(val) {
            this.areasPreloader = true
            // console.log(val.target.value)
            await this.LOAD_AREAS_BY_QUERY({query: val.target.value, demanded: this.demandedQualsOnly})
            this.areasPreloader = false
        },

        async searchKinds(val) {
            this.kindsPreloader = true
            // console.log(val.target.value)
            await this.LOAD_KINDS_BY_QUERY({query: val.target.value, demanded: this.demandedQualsOnly})
            this.kindsPreloader = false
        },

        async loadTrainings() {
            const params = {
                cur_ork_id: this.activeEl.id,
                qualification_id: this.curQualification.id
            }
            await this.SET_CURRENT_PARENT(this.curQualification.id)
            await this.SET_SHOW_DIAGRAM_ADD(false)
            await this.LOAD_INTERRELATIONS_BY_QUALIFICATION(params)

            this.nextStep()
        },

        changeActive(el) {
            this.activeEl = el
            this.SET_ORK_ID(el.id)

            this.loadTrainings()
        },
        async loadPrograms(training) {
            this.activeTraining = training;

            this.elDialogs.programs = true;
        },
        async loadProgramsForTraining(training) {

        },
        changeTabs(val) {
            this.closeDiagram = !!val
        },
        async youKnowQualification(val) {
            this.knowQualification = val

            if (!val) {
              await this.loadAllAreas()
              // await this.loadAllKinds()
            }
        },

        async loadQuals(clearQual = true) {
          if (clearQual) {
            this.curQualification = null
          }

          if (this.curKind || this.curAreas || this.curFunction) {

            const kindId = this.curKind ? this.curKind.id : null
            const funcId = this.curFunction ? this.curFunction/*.id*/ : null
            const areaId = this.curAreas ? this.curAreas.id : null

            await this.LOAD_QUALIFICATIONS({kind_id: kindId, area_id: areaId, func_id: funcId, demanded: this.demandedQualsOnly})
          }
        },

        async loadAllAreas() {
          this.areasPreloader = true
          await this.LOAD_ALL_AREAS(this.demandedQualsOnly)
          this.areasPreloader = false
        },

        async loadAllKinds() {
          this.kindsPreloader = true
          await this.SILENT_LOAD_ALL_KINDS()
          this.kindsPreloader = false
        },

        async openFilterDialog(nameFilter, filterValue) {
          this.filterPreloader = true
          this.activeFilters = this[`${nameFilter}Filter`]
          this.filterBy = nameFilter
          this.filterValue = filterValue
          this.elDialogs.filterOrk = true

          this.filterPreloader = false
        },

        addFilters({selections, nameFilter}) {
          this[`${nameFilter}Filter`] = selections
        },
    },
    computed: {
        ...mapGetters('editor', ['GET_AREA_BY_ID', 'GET_KIND_BY_ID']),
        ...mapState('career', ['qualifications', 'orks', 'interrelations', 'areas', 'kinds', 'work_functions', 'notEmptyAreas', 'autoTrajectoryQualifications']),
        ...mapState('editor', [/*'groupQualifications', 'groupKinds', 'kinds', 'qualifications', */'qualification'/*, 'orkInfo'*/,]),
        ...mapState('hints', ['hints']),

        treeInterrelations() {
            const tree = {
                qualification_to: {
                    id: this.curQualification.id,
                    code: this.curQualification.code,
                    name: this.curQualification.name,
                    trainings: this.interrelations
                }
            };

            return tree;
        },

        hintsCode() {
            return 'careerTrajectory'+this.curStep;
        },
    },
    watch: {
        qualWorkFunctionsFilter: async function(val) {
          let tempArrIds = [];

          for (const valElement of val) {
            tempArrIds.push(valElement.id);
          }

          if (tempArrIds.length > 0) {
            if (!this.lastAreas) {
              this.curAreas = null
              await this.SILENT_LOAD_AREAS_BY_FUNC({ func_id: tempArrIds, demanded: this.demandedQualsOnly} )
            }

            if (!this.lastKind) {
              this.curKind = null
              await this.SILENT_LOAD_KINDS_BY_FUNC({ func_id: tempArrIds, demanded: this.demandedQualsOnly})
            }
          }

          this.curFunction = tempArrIds

          if (!this.curKind && !this.curAreas && !this.curQualification && (!this.curFunction || this.curFunction && this.curFunction.length === 0)) {
            this.kinds = [];
            this.qualifications = [];
            await this.loadAllAreas();
          }

          await this.loadQuals(this.curQualification ? false : true)
        },
        curAreas: async function(val) {
          if (val) {
            if (!this.lastKind && !this.curFunction /*|| val != this.lastAreas*/) {
              this.curKind = null
              await this.SILENT_LOAD_KINDS_BY_AREA({area_id: val.id, demanded: this.demandedQualsOnly})
            }
          }

          if (!this.curQualification && val) {
            await this.loadQuals()
          }

          if (!val && !this.curKind && !this.curQualification && (!this.curFunction || this.curFunction && this.curFunction.length === 0)) {
            this.kinds = []
            this.qualifications = []
            await this.loadAllAreas()
          }

          if (val != this.lastAreas && val && !this.curFunction) {
            this.kinds = []
            this.curKind = null
            await this.SILENT_LOAD_KINDS_BY_AREA({area_id: val.id, demanded: this.demandedQualsOnly})
          }

          this.lastAreas = val

          this.activeEl = {}
        },
        curKind: async function(val) {
          if (val) {
            if (!this.curAreas && !this.curFunction /*|| val != this.lastKind*/) {
              this.curAreas = null
              await this.SILENT_LOAD_AREAS_BY_KIND({kind_id: val.id, demanded: this.demandedQualsOnly})
            }
          }

          if (!this.curQualification)
            await this.loadQuals()

          if (!val && !this.curAreas && !this.curQualification && (!this.curFunction || this.curFunction && this.curFunction.length === 0)) {
            this.kinds = [];
            this.qualifications = [];
            await this.loadAllAreas();
          }

          this.lastKind = val

          this.activeEl = {}
        },
        curQualification: async function(val) {

            if (val) {
              await this.SILENT_LOAD_ORKS(val.id);
              await this.LOAD_QUALIFICATION_AUTO_INTERRELATIONS(val.id);
            }

            if (!this.knowQualification) {
              if (val) {
                // if (!this.curAreas && !this.curFunction) {
                await this.SILENT_LOAD_AREAS_BY_QUAL({qual_id: val.id, demanded: this.demandedQualsOnly})
                // }
                // if (!this.curKind && !this.curFunction) {
                await this.SILENT_LOAD_KINDS_BY_QUAL({qual_id: val.id, demanded: this.demandedQualsOnly})
                // }
              }

              if (!val && !this.curKind && !this.curAreas && (!this.curFunction || this.curFunction && this.curFunction.length === 0)) {
                this.kinds = [];
                this.qualifications = [];
                await this.loadAllAreas();
              }
            }

            this.activeEl = {}
        },

        activeEl: function(val) {
            if (val && val !== '' && val.id) this.disabledNextStep = false
            else this.disabledNextStep = true
        },

        scale: function(val, oldVal) {
            const tree = this.$refs.tree.$el

            if (oldVal === 1) this.normalHeight = tree.scrollHeight
            tree.style.transform = `scale(${val})`
            tree.style.height = `${ this.normalHeight * val }px`
        },
        knowQualification: async function(val) {
            this.curQualification = null
            if (val) {
                this.qualificationPreloader = true
                await this.SILENT_LOAD_QUALIFICATIONS({})
                this.qualificationsKnow = this.qualifications
                this.demandedQualsOnlyKnow = false
                this.qualificationPreloader = false
            }
        }
    },
    created() {
        this.SELECT_NOT_FOUND = constants.SELECT_NOT_FOUND;
    },
    mounted() {
      this.LOAD_AREAS_NO_ORK();
    }
}
</script>
